import { render, staticRenderFns } from "./vSelectEditableTags.vue?vue&type=template&id=739fb0b2&"
import script from "./vSelectEditableTags.vue?vue&type=script&lang=js&"
export * from "./vSelectEditableTags.vue?vue&type=script&lang=js&"
import style0 from "./vSelectEditableTags.vue?vue&type=style&index=0&id=739fb0b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports